var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "coupon-dialog",
      attrs: {
        title: "添加优惠券到券包",
        visible: _vm.dialogVisible,
        width: "80%",
        "before-close": _vm.handleClose,
        "close-on-click-modal": false,
        top: "5vh",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _vm.dialogVisible && _vm.packageId
        ? _c(
            "div",
            { staticClass: "dialog-header" },
            [
              _c("el-alert", {
                attrs: {
                  title: "添加优惠券",
                  type: "info",
                  description:
                    "请选择要添加到券包的优惠券，可以选择多个优惠券一次性添加",
                  closable: false,
                  "show-icon": "",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c(
            "el-form",
            {
              staticClass: "filter-form",
              attrs: { inline: true, model: _vm.searchForm, size: "small" },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 15, type: "flex", align: "middle" } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 7 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "优惠券名称", "label-width": "85px" },
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: "请输入名称关键词",
                              clearable: "",
                              "prefix-icon": "el-icon-tickets",
                            },
                            nativeOn: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.handleSearch($event)
                              },
                            },
                            model: {
                              value: _vm.searchForm.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchForm, "name", $$v)
                              },
                              expression: "searchForm.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "优惠类型", "label-width": "85px" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: "请选择类型",
                                clearable: "",
                              },
                              model: {
                                value: _vm.searchForm.couponType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchForm, "couponType", $$v)
                                },
                                expression: "searchForm.couponType",
                              },
                            },
                            _vm._l(_vm.couponTypeOptions, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "状态", "label-width": "85px" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: "请选择状态",
                                clearable: "",
                              },
                              model: {
                                value: _vm.searchForm.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchForm, "status", $$v)
                                },
                                expression: "searchForm.status",
                              },
                            },
                            _vm._l(_vm.statusOptions, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    {
                      staticStyle: { "text-align": "right" },
                      attrs: { span: 5 },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "search-btn",
                          attrs: {
                            type: "primary",
                            icon: "el-icon-search",
                            size: "small",
                          },
                          on: { click: _vm.handleSearch },
                        },
                        [_vm._v("\n            搜索\n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          staticClass: "reset-btn",
                          attrs: { icon: "el-icon-refresh", size: "small" },
                          on: { click: _vm.resetSearch },
                        },
                        [_vm._v("\n            重置\n          ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.selectedCoupons.length > 0
        ? _c(
            "div",
            { staticClass: "toolbar" },
            [
              _c(
                "el-alert",
                {
                  attrs: { type: "success", "show-icon": "", closable: false },
                },
                [
                  _c("template", { slot: "title" }, [
                    _c(
                      "div",
                      { staticClass: "selection-info" },
                      [
                        _c("span", [
                          _vm._v("已选择 "),
                          _c("b", [_vm._v(_vm._s(_vm.selectedCoupons.length))]),
                          _vm._v(" 张优惠券"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticClass: "clear-btn",
                            attrs: { type: "text", size: "small" },
                            on: { click: _vm.clearSelection },
                          },
                          [
                            _c("i", { staticClass: "el-icon-delete" }),
                            _vm._v(" 清空选择\n          "),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "couponTable",
          staticStyle: { width: "100%", "margin-top": "15px" },
          attrs: {
            data: _vm.coupons,
            size: "small",
            border: "",
            "header-cell-style": {
              fontWeight: "bold",
              backgroundColor: "#f5f7fa",
            },
            "row-key": "id",
            stripe: "",
          },
          on: { "selection-change": _vm.handleSelectionChange },
        },
        [
          _c("el-table-column", {
            attrs: {
              type: "selection",
              width: "50",
              align: "center",
              fixed: "left",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "id", label: "ID", width: "80", align: "center" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "name",
              label: "优惠券名称",
              "min-width": "180",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", { staticClass: "coupon-name" }, [
                      _c("i", { staticClass: "el-icon-tickets coupon-icon" }),
                      _vm._v(
                        "\n          " + _vm._s(scope.row.name) + "\n        "
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "couponType",
              label: "优惠类型",
              width: "100",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: _vm.getTagType(scope.row.couponType),
                          size: "small",
                          effect: "dark",
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.getCouponTypeText(scope.row.couponType)
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "couponDiscountInfo",
              label: "优惠信息",
              "min-width": "180",
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (scope) {
                    return scope.row.couponDiscountInfo
                      ? _vm._l(
                          scope.row.couponDiscountInfo.split("\n"),
                          function (info, index) {
                            return _c(
                              "div",
                              { key: index, staticClass: "discount-info-line" },
                              [
                                _c("i", { staticClass: "el-icon-price-tag" }),
                                _vm._v(" " + _vm._s(info) + "\n        "),
                              ]
                            )
                          }
                        )
                      : undefined
                  },
                },
              ],
              null,
              true
            ),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "status",
              label: "状态",
              width: "100",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: _vm.getStatusTagType(scope.row.status),
                          size: "small",
                          effect: "plain",
                        },
                      },
                      [_vm._v(_vm._s(scope.row.statusDesc))]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "validityStart",
              label: "有效期",
              "min-width": "180",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      { staticClass: "validity-info" },
                      [
                        scope.row.validityType == 1
                          ? [
                              _c("i", { staticClass: "el-icon-time" }),
                              _vm._v(" 领取后 "),
                              _c("b", [_vm._v(_vm._s(scope.row.validityDays))]),
                              _vm._v(" 天\n          "),
                            ]
                          : [
                              _c("div", [
                                _c("i", { staticClass: "el-icon-date" }),
                                _vm._v(" " + _vm._s(scope.row.validityStart)),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticStyle: { "margin-top": "4px" } },
                                [
                                  _c("i", { staticClass: "el-icon-date" }),
                                  _vm._v(" " + _vm._s(scope.row.validityEnd)),
                                ]
                              ),
                            ],
                      ],
                      2
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.coupons.length === 0 && !_vm.loading
        ? _c(
            "div",
            { staticClass: "empty-block" },
            [
              _c("el-empty", {
                attrs: {
                  description: "暂无符合条件的优惠券",
                  "image-size": 120,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination-container" },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.pageData.page,
              "page-sizes": [5, 10, 20, 50],
              "page-size": _vm.pageData.limit,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total,
              background: "",
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
              "update:currentPage": function ($event) {
                return _vm.$set(_vm.pageData, "page", $event)
              },
              "update:current-page": function ($event) {
                return _vm.$set(_vm.pageData, "page", $event)
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.handleClose } }, [_vm._v("取消")]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: {
                type: "primary",
                disabled: _vm.selectedCoupons.length === 0,
                loading: _vm.confirmLoading,
                icon: "el-icon-check",
              },
              on: { click: _vm.confirmAdd },
            },
            [_vm._v("\n      确定添加\n    ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }